import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_ADMINS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_ADMIN,
  UPDATE_ADMIN,
  DELETE_ADMIN
 } from "./actionTypes";
import {
  getAdminsSuccess,
  getAdminsFail,
  addAdminSuccess,
  addAdminFail,
  updateAdminSuccess,
  updateAdminFail,
  deleteAdminSuccess,
  deleteAdminFail,
  // getAdminProfileSuccess,
  // getAdminProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getAdmins,
  // getAdminProfile,
  addNewAdmin,
  updateAdmin,
  deleteAdmin,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchAdmins({payload}) {
  try {
    const response = yield call(getAdmins,payload);
    yield put(getAdminsSuccess(response));
  } catch (error) {
    yield put(getAdminsFail(error));
  }
}

function* onUpdateAdmin ({payload: admin }) {
  try {
   let response = yield call(updateAdmin, admin);
  if(response.file_src || admin.removeImage)  {admin.main_img = response.file_src }else{delete admin.main_img}
    yield put(updateAdminSuccess(admin));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(updateAdminFail(error));
    yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteAdmin({ payload: admin }) {
  try {
   let response = yield call(deleteAdmin, admin);
    yield put(deleteAdminSuccess(admin));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteAdminFail(error));
    yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewAdmin({ payload: admin }) {

  try {
   let response = yield call(addNewAdmin, admin);
    yield put(addAdminSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(addAdminFail(error));
    yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchAdminProfile() {
//   try {
//     const response = yield call(getAdminProfile);
//     yield put(getAdminProfileSuccess(response));
//   } catch (error) {
//     yield put(getAdminProfileFail(error));
//   }
// }

function* adminsSaga() {
  yield takeEvery(GET_ADMINS, fetchAdmins);
  yield takeEvery(ADD_NEW_ADMIN, onAddNewAdmin);
  yield takeEvery(UPDATE_ADMIN, onUpdateAdmin);
  yield takeEvery(DELETE_ADMIN, onDeleteAdmin);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchAdminProfile);
}

export default adminsSaga;
